export async function streamCompanion(entryId, payload, onRaw, signal) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/entries/${entryId}/companion`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });
  if (!res.ok || !res.body) throw new Error("companion request failed");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let raw = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let cut;
    while ((cut = buffer.indexOf("\n\n")) >= 0) {
      const chunk = buffer.slice(0, cut);
      buffer = buffer.slice(cut + 2);
      if (!chunk.startsWith("data: ")) continue;
      const ev = JSON.parse(chunk.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.intervention) return ev.intervention;
      if (ev.text) { raw += ev.text; onRaw(raw); }
    }
  }
  throw new Error("companion stream ended early");
}

// Visible part of a reply while it streams; empty means "still reading"
export function liveText(kind, raw) {
  const text = raw.replace(/[¡!]/g, "");
  if (text.includes("[")) return "";
  if (kind === "close") return text.trim();
  const m = text.match(/PREGUNTA:\s*([\s\S]*)/);
  return m ? m[1].trim() : "";
}
